<div class="bigPage">
  <ng-container *ngIf="dataEvento; else loading">
    <div class="bigPage_cont">
      <!-- HEADER DE LA VISTA -->
      <div class="bigPage_header">
        <div class="bigPage_nav">
          <h3 class="mat-headline">{{dataEvento.categoria}}</h3>
          <span class="spacer"></span>
          <a class="enlace-boton"
             [routerLink]="['/', 'estudio', 'unidad', unidadID, {outlets: {retroalimentacion:['retroalimentacion', eventoUnidadID]}}]"><i
            class="material-icons">
            group
          </i><span>Volver a alumnos</span></a>
          <a class="enlace-boton" [routerLink]="['/', 'estudio', 'unidad', unidadID]" fragment="evidencias"><i
            class="material-icons">
            arrow_back
          </i><span>Volver a evidencias</span></a>
        </div>
        <div>
          <div class="bigPage_data">
            <h3 class="mat-small">Evidencia</h3>
            <p class="mat-chip-frame">{{dataEvento.nombre}}</p>
            <h3 class="mat-small">Metas relacionadas</h3>
            <mat-chip-set>
              <mat-basic-chip *ngFor="let meta of dataEvento.metas"
                              matTooltip="{{meta.txtFR.length > 3 ? meta.txtFR : meta.txtEN.length > 3 ? meta.txtEN : meta.txtES}}">
                {{meta.codigo}}-{{meta.id}}
              </mat-basic-chip>
            </mat-chip-set>
            <mat-form-field class="full-width" style="margin-top:24px;">
              <mat-select [formControl]="alumnoMultiCtrl" (selectionChange)="changeStudent($event)"
                          placeholder="Alumno para esta retroalimentación">
                <mat-option *ngFor="let alumno of dataEvento.materias.alumnos" [value]="alumno">
                  {{alumno.apellidosNombres}}
                  <small style="opacity: .6;">({{alumno.criteriosEvaluados}} criterios evaluados
                    de {{alumno.criteriosTotales}})
                  </small>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- FIN HEADER DE LA VISTA -->
      <div class="bigPage-cont">
        <div class="flex-wrap bigPage_content">
          <div class="bigPage_main">
            <div>
              <div class="flex-wrap" style="align-items:baseline;">
                <h3 class="mat-h2">Evaluación</h3>
                <span class="spacer"></span>
                <mat-slide-toggle color="primary" labelPosition="before" [checked]="showExtendedInfo"
                                  (change)="showExtendedInfo = !showExtendedInfo">
                  {{showExtendedInfo ? 'Contraer' : 'Expandir'}}
                </mat-slide-toggle>
              </div>
              <ng-container *ngFor="let meta of dataEvento.metas">
                <ng-container *ngFor="let criterio of meta.criterios">
                  <div class="criterio-row mat-elevation-z2">
                    <div class="full-width criterio">
                      <h3 class="mat-h3">
                        <mat-basic-chip style="margin-left: 0px; top: 0px; margin-bottom: 0px">{{meta.codigo}}
                          -{{meta.id}}</mat-basic-chip>
                        {{meta.txtFR.length > 0 ? meta.txtFR : meta.txtEN.length > 0 ? meta.txtEN : meta.txtES}}
                      </h3>
                      <h3 class="mat-small">Criterio
                        <ng-container *ngIf="criterio.niveles.length > 1; else nivelesLabel">
                          <a routerLink="." [matMenuTriggerFor]="menuniveles"
                             style="margin-left: 8px;">{{getSelectedNivel(criterio).nombre}}</a>
                          <mat-menu #menuniveles="matMenu">
                            <button mat-menu-item *ngFor="let niv of criterio.niveles; index as i"
                                    (click)="setVisibilityNivel(niv, criterio);">
                              <span>{{niv.nombre}}</span>
                            </button>
                          </mat-menu>
                        </ng-container>
                      </h3>
                      <p class="mat-chip-frame">{{criterio.nombre}}</p>
                    </div>
                    <div class="flex-wrap">
                      <div *ngIf="dataEvento.materias.fechas && dataEvento.materias.fechas.length > 0; else noFechas" class="inline-flex" style="flex-grow: 5;">
                        <ng-container *ngFor="let fecha of dataEvento.materias.fechas">
                          <div class="flex-wrap" style="align-items: center; margin-top:12px;">
                            <mat-icon class="md-14" style="margin-right: 4px;">calendar_today</mat-icon>
                            <small>{{fecha.substring(0, 10)}}</small>
                          </div>
                          <ng-container *ngFor="let nivel of criterio.niveles; index as i">
                            <div class="flex-wrap" *ngIf="nivel.isSeleccionado">
                              <ng-container *ngFor="let criterioHijo of nivel.criterios">
                                <ng-container *ngIf="nivel.canEvaluate; else notEvaluable">
                                  <div (click)="setEvaluacion(criterioHijo, nivel, fecha)"
                                       [ngClass]="{'logro_seleccion': criterioHijo[fecha]['selected']}"
                                       matTooltip="Evaluar con {{criterioHijo.escala.nombre}}" class="logro">
                                    <label style="opacity:.6">
                                      <small><strong>{{criterioHijo.escala.nombre}}</strong></small>
                                    </label>
                                    <ng-container *ngIf="showExtendedInfo">
                                      <div>
                                        <p *ngIf="criterioHijo.escala.nickName !== 'P'; else pendiente">
                                          {{criterioHijo.nombre}}</p>
                                        <ng-template #pendiente>
                                          <p>Pendiente</p>
                                        </ng-template>
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-container>
                                <ng-template #notEvaluable>
                                  <div matTooltip="No evaluable, existe evaluación en otro nivel." class="logro"
                                       style="cursor: default">
                                    <label style="opacity:.6">
                                      <small><strong>{{criterioHijo.escala.nombre}}</strong></small>
                                    </label>
                                    <ng-container *ngIf="showExtendedInfo">
                                      <div>
                                        <p *ngIf="criterioHijo.escala.nickName !== 'P'; else pendiente">
                                          {{criterioHijo.nombre}}</p>
                                        <ng-template #pendiente>
                                          <p>Pendiente</p>
                                        </ng-template>
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-template>
                              </ng-container>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                      <ng-template #noFechas>
                        <br>
                        <mat-icon>warning</mat-icon><p>No hay fechas de evaluación asignadas para la materia de este estudiante.</p>
                      </ng-template>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="bigPage_aux">
            <h3 class="mat-h2">Retroalimentación</h3>
            <div *ngIf="enableComentario" class="">
              <glm-comentarios [comentarios]="comentarios"
                               [fechas]="commentFechas"
                               [targetID]="commentTargetID"
                               [origen]="'unidadeventoalumno'"></glm-comentarios>
            </div>
            <div *ngIf="enableComentario == false">
              <p style="opacity:.6;"><span style="color:red">Sin criterios evaluados.</span> Evalúe por lo menos un
                criterio para activar la retroalimentación.</p>
            </div>
            <h3 class="mat-h2">Mis apuntes y notas</h3>
            <div class="">
              <glm-comentarios [comentarios]="comentariosPrivados"
                               [targetID]="commentTargetID"
                               [origen]="'unidadeventoalumnoprivado'"></glm-comentarios>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <mat-spinner mode="indeterminate"></mat-spinner>
  </ng-template>
</div>
